import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";

/**
 * Guards routes by:
 *  - presence of user (else /login)
 *  - role (else /login for missing-role redirect to the right home)
 *  - active subscription (agents only; else /subscribe)
 *  - onboarded flag (agents only; else /onboarding)
 */
export default function ProtectedRoute({
  children,
  requireOnboarded = true,
  requireSubscription = true,
  role = null, // "owner" | "agent" | null = any authenticated user
}) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-sg-paper">
        <div className="animate-pulse text-sg-mute font-mono text-xs">Loading…</div>
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  if (role) {
    const allowed = Array.isArray(role) ? role : [role];
    if (!allowed.includes(user.role)) {
      // wrong role → bounce to their own home
      return <Navigate to={user.role === "owner" ? "/admin" : "/dashboard"} replace />;
    }
  }
  if (user.role === "agent") {
    if (requireSubscription && user.subscription_status !== "active") {
      return <Navigate to="/subscribe" replace />;
    }
    if (requireOnboarded && !user.onboarded) {
      return <Navigate to="/onboarding" replace />;
    }
  }
  return children;
}
